const secondsToTime = (seconds, secondsPrefix, minutesPrefix) => {
  if (seconds === Infinity || seconds === -Infinity || Number.isNaN(seconds)) {
    seconds = 0;
  }
  seconds = Math.round(seconds);

  const hours = Math.floor(seconds / 3600);
  const divirsForMinutes = seconds % 3600;
  const minutes = Math.floor(divirsForMinutes / 60);
  const sec = Math.ceil(divirsForMinutes % 60);

  const times = {
    hh: hours.toString(),
    mm: minutes < 10 ? `0${minutes}` : minutes.toString(),
    ss: sec < 10 ? `0${sec}` : sec.toString()
  };
  if (seconds < 60) {
    return secondsPrefix + times.ss;
  }
  if (seconds < 3600) {
    return `${minutesPrefix + times.mm}:${times.ss}`;
  }
  return `${times.hh}:${times.mm}:${times.ss}`;
};

export default secondsToTime;
